import _ from "lodash";
import * as Tag from "@/helper/characteristic/Tag";
import {MARKETING_AREA} from "@/helper/characteristic/Type";

export const RELEVANT_SUPPLEMENT_TYPES = [
	MARKETING_AREA
];

export function isNothingAllowedEligible (employmentModes)
{
	if (!employmentModes)
	{
		return false;
	}

	const eligibleItems = _.filter(
		employmentModes,
			characteristic => Tag.hasTag(characteristic, Tag.FUNCTION_NOTHING_ALLOWED)
	);

	return eligibleItems.length === employmentModes.length;
}